import { Route } from '@angular/router';
import { accessGuard } from '@core';
import { UserManagementComponent } from '@feature/user-management';

export const DEFAULT_USER_MANAGEMENT_ROUTES: Route[] = [
  {
    path: 'user-management',
    component: UserManagementComponent,
    data: {
      nav: {
        label: 'view_value.user_management',
        icon: 'assets/shared/icons/people.svg',
        mini_icon: 'assets/shared/icons/black/people.svg',
        class: 'icon-50',
        order: 90,
      },
      access: { modules: ['user_management'], roles: ['Admin', 'Super Admin'] },
    },
    canMatch: [accessGuard],
  },
];
